// extracted by mini-css-extract-plugin
export default {"button":"ButtonShare_button__C-eGC"};